export const InventoryLimits = {
  minQuantity: 1,
  maxQuantity: 999,
  minCost: 0.01,
  maxAttachmentsPerItem: 10,
  maxAttachmentMegabytes: 45,
  maxTextLength: 4000,
  maxShortTextLength: 100,
  maxReceiptIncludedLength: 10,
  maxCostIntegerDigits: 16,
  maxCostDecimalDigits: 2,
  maxFormattedCostLength: 24,
} as const;

export const MaxAttachmentBytes =
  InventoryLimits.maxAttachmentMegabytes * 1024 * 1024;

export function formatInventoryFileSize(
  bytes?: number | null,
): string {
  if (bytes == null || Number.isNaN(bytes)) {
    return '';
  }

  const megabytes = bytes / (1024 * 1024);
  return `${megabytes.toFixed(2)} MB`;
}

export function parseCost(value: unknown): number {
  const digits = String(value ?? '').replace(/[^0-9.]/g, '');
  const parsed = parseFloat(digits);

  return isNaN(parsed) ? 0 : parsed;
}

export const InventoryAttachmentExtensions = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.pdf',
  '.rtf',
  '.tif',
  '.tiff',
  '.txt',
  '.docx',
  '.heic',
  '.heics',
  '.heif',
  '.heifs',
] as const;
